import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from "@mui/material";
import React from "react";
import useConfig from "../../../hooks/useConfig";
import PageRoutes from "../../../utils/constants";

const AlertBox = ({
  handleClose,
  open,
  content,
  buttonText,
  buttonAction,
}: any) => {
  const configData = useConfig();
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      sx={{ width: 1 }}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText
          sx={{ fontStyle: "normal", textTransform: "none !important" }}
          id="alert-dialog-description"
        >
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "block" }}>
          <button
            style={{ display: "block" }}
            className={configData.buttonCommonClass}
            onClick={() => buttonAction()}
            autoFocus
          >
            {buttonText}
          </button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
export default AlertBox;
